.indicator {
  display: none;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: rgb(0 0 0 / 20%);
  border-radius: 50%;

  &:focus {
    outline: none;
  }
}

.dotActive {
  background-color: #000;
}

@container press-release-root (min-width: 1280px) {
  .indicatorCQ {
    display: flex;
    gap: 4px;
    justify-content: flex-end;
  }
}

@media screen and (width >= 1280px) {
  .indicatorFallback {
    display: flex;
    gap: 4px;
    justify-content: flex-end;
  }
}
